var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacheravatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 280,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 36a56 56 0 0 0-56 56v6.17A12 12 0 0 0 66 110v14a12 12 0 0 0 10.3 11.88 56.04 56.04 0 0 0 31.7 44.73v18.4h-4a72 72 0 0 0-72 72v9h200v-9a72 72 0 0 0-72-72h-4v-18.39a56.04 56.04 0 0 0 31.7-44.73A12 12 0 0 0 198 124v-14a12 12 0 0 0-10-11.83V92a56 56 0 0 0-56-56Z",
    fill: "#ae5d29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 180.61v8a55.79 55.79 0 0 0 24 5.39c8.59 0 16.73-1.93 24-5.39v-8a55.79 55.79 0 0 1-24 5.39 55.79 55.79 0 0 1-24-5.39Z",
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.5 54C151 54 166 44.37 166 32.5c0-1.1-.13-2.18-.38-3.23A72 72 0 0 1 232 101.05V110H32v-8.95A72 72 0 0 1 99.4 29.2a14.1 14.1 0 0 0-.4 3.3C99 44.37 114 54 132.5 54Z",
    fill: "#ff488e"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.27 30.13c3.28-.56 5.73-3.55 5.18-6.79-.46-2.72-1.74-.34-2.97.86-1.34 1.3-2.45 2.57-4.54 2.05-3.6-.9-4.86-5.4-3.84-8.48a5.94 5.94 0 0 1 3.48-3.7c1.85-.74 3.2.1 4.75 1.1.28.19 1.73 1.37 2 1.25.45-.21.1-2.43.04-2.73a4.8 4.8 0 0 0-2.62-3.24c-3.34-1.64-7.52.48-9.64 3.05-4.88 5.9-.91 18.17 8.17 16.62ZM20.28 11.04Zm-1.6 12.86c.51 3.48 2.99 6.5 6.96 6.36 4.28-.16 6.06-4.1 7-7.49.97-3.4 2.06-7.68.67-11.09-.42-1.03-.68-2.38-1.71-1.53-1.26 1.03-1.41 4.04-1.52 5.44-.2 2.65-.78 9.97-4.1 10.95-4.18 1.22-4.05-5.85-4-7.98.03-1.9.24-3.73-.35-5.58-.31-.99-.59-2.44-1.53-1.64-1.29 1.11-1.45 3.83-1.54 5.33-.14 2.4-.21 4.84.13 7.23ZM37.78 26.75c.2.4.63 1.4 1.02 1.67.95.67-.05.71.8-.05.82-.73 1.13-2.72 1.26-3.67.38-2.96-.12-6.11-.09-9.1 1.02 2.22 1.58 4.59 2.39 6.88.55 1.58 1.4 4.8 3.65 4.75 2.45-.05 2.58-3.14 2.9-4.82.47-2.37.97-4.72 1.68-7.04.1 3.91-1.43 11 2.1 13.92.02.02 1.44-4.15 1.47-4.4.23-1.7.09-3.45.11-5.15.05-3.6.72-8-.3-11.5-.33-1.14-.97-2.27-2.4-2.24-1.83.04-2.24 1.99-2.7 3.3a114.02 114.02 0 0 0-3.36 10.94c-.55-1.68-5.34-16.42-8.8-10.9-.55.89-.3 2.22-.33 3.2-.04 1.87-.15 3.75-.2 5.63-.06 2.84-.4 5.9.81 8.58ZM62.02 13.71c.72-.14 5.74-1.73 5.52-.14-.22 1.68-4.63 3.31-5.81 3.88 0-1.2-.24-2.44-.65-3.57l.94-.17Zm5.72-.64c-.03-.04 0 0 0 0Zm.12 8.34c2.27 1.22 1.29 3.42-.43 4.6-.65.47-6.53 1.82-6.51 1.68.18-1.69-.26-5.01 1-6.01 1.3-1.04 4.5-.81 5.94-.26Zm.06-8s.01.03 0 0Zm-9.98 16.85c.23.55.86 1.91 1.57 1.94.86.04.8-1.04.93-1.7 3.44 1.72 8.5-.05 10.9-3.03a6.15 6.15 0 0 0-2.57-9.75c2.1-1.69 4.02-5.4 1.25-7.49a7.68 7.68 0 0 0-8.12-.3c-2.74 1.72-3.85 5.83-4.1 9-.25 3.39-1.15 8.13.14 11.33ZM76.05 21.87c.07 2.07-.15 4.29.33 6.3.17.72.44 1.52.76 2.17.61 1.21.31 1.05 1.03.36 2.18-2.08 1.21-8.58 1.16-11.25-.04-2.08.06-4.28-.51-6.28-.16-.56-1.12-3.35-1.66-3.29-.81.1-1.37 3.93-1.42 4.7-.15 2.4.23 4.9.31 7.3ZM94.75 22.43c-1.58-.14-3.62.07-5.12.56.7-1.92 1.48-4.06 2.24-5.8.47-1.08.97-2.16 1.5-3.23 1.27 2.68 1.98 5.82 2.82 8.66-.47-.08-.96-.15-1.44-.19Zm5.44.72c-.73-2.77-1.58-5.53-2.43-8.27-.54-1.75-1.13-3.92-2.6-5.17-4.16-3.56-6.52 5.85-7.55 8.23-.98 2.3-2.21 4.63-2.85 7.05a9.48 9.48 0 0 0-.24 3.64c.2 1.52 0 1.74 1.3.91 1-.63 1.4-1.79 2.22-2.56.14-.14.22-.68.4-.76.18-.1 1.5.25 1.8.27 2.18.16 4.72-.2 6.72-1.04.2.84 1.63 5.96 2.98 5.77.6-.08.96-3.06 1-3.54.08-1.55-.36-3.05-.75-4.54ZM109.3 9.43c-.26-1.2-.81-3.29-1.84-2.11-1.4 1.6-1.1 5.17-1.11 7.18-.02 1.45-1.55 12.06.56 11.88-.1 0 .84-1.67.98-1.92a12.37 12.37 0 0 0 1.32-4.72c.37-3.24.79-7.12.1-10.3ZM108.16 30.3c-2.23-2.73-6.3.66-5.04 3.38 1.73 3.7 7.33-.57 5.04-3.38ZM94.9 34.54c-2.9-.73-6.3-.24-9.25-.15-3.08.1-6.16.27-9.24.36-6.57.2-13.13.1-19.7.04-12.44-.1-24.92.69-37.37.17-2.67-.12-5.54-.72-8.2-.21-.72.14-3 .54-3.32 1.26-.34.76 1.4 1.56 2.33 1.96 2.42 1.04 5.33.86 7.9.96 2.93.12 5.89.06 8.82-.01 12.07-.3 24.09-1.34 36.18-1.17 6.97.1 13.93.04 20.9 0 3.33-.01 7 .53 10.28-.06.55-.1 3.76-.85 3.8-1.83.03-.46-2.8-1.23-3.12-1.32Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 134)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18,
    width: 24,
    height: 6,
    rx: 3,
    fill: "#000",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104 122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8c0 4.42 5.37 8 12 8s12-3.58 12-8",
    fill: "#000",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 16c-4.84 0-9 2.65-10.84 6.45-.54 1.1.39 1.85 1.28 1.12a15.13 15.13 0 0 1 9.8-3.22 6 6 0 1 0 10.7 2.8 2 2 0 0 0-.12-.74l-.15-.38a6 6 0 0 0-1.64-2.48C33.9 17.32 30.5 16 27 16ZM85 16c-4.84 0-9 2.65-10.84 6.45-.54 1.1.39 1.85 1.28 1.12a15.13 15.13 0 0 1 9.8-3.22 6 6 0 1 0 10.7 2.8 2 2 0 0 0-.12-.74l-.15-.38a6 6 0 0 0-1.64-2.48C91.9 17.32 88.5 16 85 16Z",
    fill: "#000",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76 82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.23 20.42-.9.4c-5.25 2.09-13.2 1.21-18.05-1.12-.57-.27-.18-1.15.4-1.1 14.92 1.14 24.96-8.15 28.37-14.45.1-.18.41-.2.49-.03 2.3 5.32-4.45 13.98-10.3 16.3ZM80.77 20.42l.9.4c5.25 2.09 13.2 1.21 18.05-1.12.57-.27.18-1.15-.4-1.1-14.92 1.14-24.96-8.15-28.37-14.45-.1-.18-.41-.2-.49-.03-2.3 5.32 4.45 13.98 10.3 16.3Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 145c-.62-30.84 28.32-95.2 39-108 7.92-9.5 29.7-17.45 54-17 24.3.45 46.86 5.81 55 16 12.32 15.43 37.87 74.08 38 109 .1 24.8-9.54 49.66-23 51-7.6.76-17.26-.23-28.86-1.4-5.3-.55-11.02-1.13-17.14-1.6V180.6A56 56 0 0 0 189 130v-28.44a130.34 130.34 0 0 1-26.9-19.88c3.35 6.24 7.19 11.9 11.51 16.2-30.57-8.59-51.71-26.16-64.38-39.94C103.39 69.02 92.96 85.23 77 97.57V130a56 56 0 0 0 32 50.61v13.14c-6.95.95-13.41 2.16-19.36 3.27-10.85 2.02-19.98 3.73-27.26 2.98-14.22-1.47-21.88-30.2-22.38-55Z",
    fill: "#d6b370"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 72)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacheravatar);
export default __webpack_public_path__ + "static/media/teacheravatar.47d1b53058b8e03951a88332a5b0b4dd.svg";
export { ForwardRef as ReactComponent };